import * as React from 'react';
export const createComponentThatRendersItsChildren = displayName => {
  const Element = _ref => {
    let {
      children
    } = _ref;
    return typeof children === 'string' ? /*#__PURE__*/React.createElement('div', {}, children) : children;
  };
  Element.displayName = displayName;
  return Element;
};
//# sourceMappingURL=createComponentThatRendersItsChildren.js.map